import { callApi } from '../../../../api/call';

const getEmailSettings = async (companyId) => {
  const response = await callApi(`/api/companies/${encodeURIComponent(companyId)}/email-settings/get`, {
    companyId,
  });
  return response.data;
};

const updateEmailSettings = async (companyId, settings) => {
  const response = await callApi(`/api/companies/${encodeURIComponent(companyId)}/email-settings`, {
    settings,
  });
  return response.data;
};

const sendTestEmail = async (companyId, templateType, testEmail) => {
  const response = await callApi(`/api/companies/${encodeURIComponent(companyId)}/email-settings/test`, {
    templateType,
    testEmail,
  });
  return response.data;
};

const sendManualReminder = async (companyId, appointmentId, channels) => {
  const payload = {};
  if (Array.isArray(channels) && channels.length) payload.channels = channels;
  const response = await callApi(
    `/api/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(appointmentId)}/reminders`,
    payload
  );
  return response.data;
};

export const emailSettingsService = {
  getEmailSettings,
  updateEmailSettings,
  sendTestEmail,
  sendManualReminder,
};
